import Feature1 from "./feature1/feature1";

export default function _Feature(props) {
  let eleHTML = <></>;
  if (!props.display) return eleHTML;

  switch (props.display) {
    case "feature1":
      eleHTML = <Feature1 options={props.options} />;
      break;
    default:
      break;
  }

  return eleHTML;
}
